import { useEffect, useLayoutEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Grid, IconButton, Link, TextField, Typography } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import TexBoxWithLabel from "../../../../components/text-field";
import ValidationError from "../../../../components/validation-error-label";
import AutoCompleteDropDown from "../../../../components/auto-complete-dropdown";
import { GetLocalStorage } from "../../../../utils/local-storage";
import APIS from "../../../../config/api";
import { GET, POST } from "../../../../config/https";
import RichBoxUi from "../../../../components/richbox";
import ImageSelectionComponent from "../../../../components/Image-selection-component/ImageSelectionComponent";
import {
  isEmpty,
  isFileSizeWithinLimit,
  isValidFileExtension,
  isValidImageFormat,
} from "../../../../utils/validator";
import { usePersistentState } from "../../../../contexts/global-context";
import { useLocation, useNavigate } from "react-router-dom";
import { STRING } from "../../../../resources/string";
import FullScreenLoader from "../../../../components/full-screen-loader";
import Color from "../../../../theme/color";

interface formDataTypes {
  title?: string;
  organizerId?: null;
  description?: string;
  eventCategoryId?: null;
  VideoUrl?: string;
  organizerName?: string;
}

const formData = {
  title: "",
  organizerId: null,
  description: "",
  imageBase64: "",
  imageBase64Other: "",
  eventCategoryId: null,
  VideoUrl: "",
  organizerName: "",
};

const coverImagesProps = {
  name: "",
  data: "",
  id: 0,
};
interface coverImagesPropsTypes {
  name?: string;
  data: string;
  id?: number;
}

const EventDetails = ({ wizardKey, addEventType }: EventTicketConfigProps) => {
  const location: any = useLocation();
  const navigate = useNavigate();
  let route = location?.state?.id;
  const [state, dispatch]: any = usePersistentState();
  const [eventDetail, setEventDetail] = useState<formDataTypes>(formData);
  const [coverImages, setCoverImages] =
    useState<coverImagesPropsTypes>(coverImagesProps);
  const [otherImages, setOtherImages] = useState<
    { name: string; data: string; id: number }[]
  >([]);
  const [allOrganizer, setAllOrganizer] = useState([]);
  const filteredOrganizers = allOrganizer?.filter(
    (organizer: any) =>
      organizer?.companyName !== null && organizer?.companyName !== undefined
  );
  const [eventCategories, setEventCategories] = useState([]);
  const [isValidation, setIsValidation] = useState(false);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [description, setDescription] = useState("");
  const [isGetById, setIsGetById] = useState(false);
  const [userData, setUserData] = useState<any>({});
  const [loginInfo, setLoginInfo] = useState<any>(false);
  const [isCoveredImageValidation, setIsCoveredImageValidation] = useState("");
  const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"];
  useEffect(() => {
    GetUserData();
  }, []);
  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  const GetUserData = async () => {
    let userData = GetLocalStorage("loginData");
    let params: any = {
      id: userData.id,
    };
    await GET(APIS.GET_USER_BY_ID, params)
      .then((res: any) => {
        if (res?.isSuccess) {
          setUserData(res?.result);
        } else {
          console.log("GetUserData error");
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    let tempData = GetLocalStorage("loginData");
    setLoginInfo(tempData);
  }, [state.users]);

  useEffect(() => {
    if (isValidation) {
      validator();
    }
  }, [eventDetail, coverImages, isValidation]);

  useEffect(() => {
    let EventData: any = localStorage.getItem("eventDetails");
    if (EventData) {
      let newData = JSON.parse(EventData);
      let eventDetailNewData = eventDetail;
      eventDetailNewData.title = newData?.title;
      eventDetailNewData.organizerId = newData?.organizer;
      eventDetailNewData.eventCategoryId = newData?.eventCategory;
      eventDetailNewData.description = newData.description;
      eventDetailNewData.VideoUrl = newData?.videoUrl;
      eventDetailNewData.organizerName = userData?.companyName;
      setEventDetail(eventDetailNewData);

      let coverImage = newData?.eventBanners.map((x: any) => {
        if (!x?.isCoverdImage) return;
        let newData = {
          data: x?.filePath,
          name: "",
          id: x?.id,
        };
        return newData;
      });
      let otherImages: [] = newData?.eventBanners.map((x: any) => {
        if (x?.isCoverdImage) return;
        let newData = {
          data: x?.filePath,
          name: "",
          id: x?.id,
        };
        return newData;
      });
      const finalCoverImage = coverImage?.find(
        (item: any) => item !== undefined
      );
      setCoverImages(finalCoverImage);
      setOtherImages(otherImages);
    } else {
      eventDetail.title = "";
      eventDetail.organizerId =
        loginInfo?.roles?.name === STRING.ROLE.HOSTS ? userData : null;
      eventDetail.eventCategoryId = null;
      eventDetail.description = "";
      eventDetail.VideoUrl = "";
      eventDetail.organizerName = userData?.companyName;
    }

    if (isGetById) {
      setIsGetById(false);
    }
    dispatch({ IsGetByIdEvent: false });
  }, [state.IsGetByIdEvent, route, userData]);

  useEffect(() => {
    if (state.WizardKey === 0 && state.AddEventType === "AddEventDetail") {
      setIsValidation(true);
      if (!validator()) {
        dispatch({
          AddEventType: "",
        });
        return;
      }
      AddMethod();
    }
  }, [state.WizardKey, state.AddEventType, state.toggleState]);

  useEffect(() => {
    getAllEventCategories();
    getAllOrganizer();
  }, []);

  useEffect(() => {
    setDescriptionData();
  }, [description]);

  const AddMethod = async () => {
    let isSuccess = await AddEventDetail();
    if (isSuccess) {
      dispatch({ WizardKey: state.WizardKey + 1, AddEventType: "" });
    }
  };

  const getAllEventCategories = async () => {
    let param: any = {
      PageSize: 100,
      IsDescending:false,
      SortProperty:"displayName"
    };
    await GET(APIS.GET_ALL_EVENT_CATEGORIES, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          setEventCategories(res?.result);
        }
      })
      .catch(() => {
        console.log("error");
      });
  };
  const getAllOrganizer = async () => {
    let param = {};
    await GET(APIS.GET_ALL_USER, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          setAllOrganizer(res?.result);
        }
      })
      .catch(() => {
        console.log("error");
      });
  };

  const onChangeFormData = async (key: string, e: any) => {
    let newData = { ...eventDetail };
    switch (key) {
      case "title":
        newData.title = e.target.value;
        break;
      case "videoUrl":
        newData.VideoUrl = e.target.value;
        break;
      case "organizerName":
        newData.organizerName = e.target.value;
        break;
    }
    setEventDetail(newData);
  };
  const handleOnChange = (newValue: any) => {
    let newData = { ...eventDetail };
    newData.eventCategoryId = newValue;
    setEventDetail(newData);
  };

  const handleOnChangeOrganizer = (newValue: any) => {
    let newData = { ...eventDetail };
    newData.organizerId = newValue;

    setEventDetail(newData);
  };

  const saveRichBox = (data: any) => {
    setDescription(data);
  };
  const setDescriptionData = () => {
    let newData = { ...eventDetail };
    newData.description = description;
    setEventDetail(newData);
  };

  const handleChangeCoverImage = (event: any) => {
    const file = event.target.files[0];

    if (file && allowedFileTypes.includes(file.type)) {
      const reader = new FileReader();
      reader.onloadend = (e: any) => {
        const base64: any = e.target.result;
        let newData = { ...coverImages };
        newData.data = base64;
        newData.id = 0;
        newData.name = "test";
        setCoverImages(newData);
      };
      reader.readAsDataURL(file);
      setIsCoveredImageValidation("");
    } else {
      setIsCoveredImageValidation(
        "Please select a valid JPEG, JPG, or PNG file."
      );
      event.target.value = null;
    }
  };

  const handleDeleteClickCoverImage = () => {
    setCoverImages(coverImagesProps);
  };

  const AddEventDetail = async () => {
    let EventId: any = localStorage.getItem("eventDetails");
    let eventId = JSON.parse(EventId);
    setIsValidation(true);
    if (!validator()) {
      dispatch({
        AddEventType: "",
      });
      setIsValidation(false);
      return;
    }

    dispatch({ FullScreenLoader: true });
    let temp: any = eventDetail;
    let imageOtherData = otherImages?.map((x: any) => {
      let base64;
      if (x?.data === undefined) return;
      if (x?.id === 0) {
        base64 = x?.data?.split(",")[1];
        return { data: base64, name: x?.name, id: x?.id };
      }
      return { data: x?.data, name: x?.name, id: x?.id };
    });
    if (!Array.isArray(imageOtherData)) {
      imageOtherData = [];
    }
    let param = {
      id: eventId?.id,
      title: temp?.title,
      description: temp?.description,
      eventCategoryId: temp?.eventCategoryId?.id,
      organizerId:
        loginInfo?.roles?.name === STRING.ROLE.HOSTS
          ? userData?.id
          : temp?.organizerId?.id,
      organizerName: userData?.companyName || temp?.organizerName,
      videoUrl: temp?.VideoUrl,
      eventBannerCoverd: {
        data: coverImages?.data?.split(",")[1] || coverImages?.data,
        name: coverImages?.name,
        id: coverImages?.id,
      },
      eventBannerOtherImage: imageOtherData.filter(
        (element) => element !== undefined
      ),
    };
    try {
      const res: any = await POST(APIS.ADD_EVENT_DETAIL, param);
      if (res?.isSuccess) {
        localStorage.setItem("eventDetails", JSON.stringify(res?.result));
        dispatch({ AddEvent: res?.result });
        if (state.FilledSteps[state.FilledSteps.length - 1] < 5) {
          const updatedSteps = state.FilledSteps.includes(1)
            ? [...state.FilledSteps]
            : [...state.FilledSteps, 1];
          dispatch({ FilledSteps: updatedSteps });
        }
        return true;
      } else {
        return false;
      }
    } catch (error) {
    } finally {
      dispatch({ FullScreenLoader: false });
      setIsValidation(false);
    }
  };

  const validator = () => {
    const errors: Record<string, string> = {};

    if (eventDetail && isEmpty(eventDetail?.title ?? "")) {
      errors.title = "Please enter a Title";
    }

    if (isEmpty(eventDetail?.description ?? "")) {
      errors.description = "Please enter a description";
    }

    if (!eventDetail?.eventCategoryId) {
      errors.eventCategoryId = "Please select a Event Category ";
    }
    if (!eventDetail?.organizerId) {
      errors.organizerId = "Please select a Company / Organizer ";
    }

    if (!coverImages?.data) {
      errors.coveredImage = "Please select covered Image";
    } else {
      const { data, id } = coverImages;

      if (id === 0) {
        if (!isValidImageFormat(data)) {
          errors.coveredImage = "Invalid Image Format";
        } else if (!isValidFileExtension(data)) {
          errors.coveredImage = "Invalid File Extension";
        } else if (!isFileSizeWithinLimit(data)) {
          errors.coveredImage =
            "Invalid Image Size. Image size should be less than 10mb.";
        }
      }
    }
    if (otherImages.length > 0) {
      otherImages?.forEach((image, index) => {
        if (image?.id === 0) {
          const { data } = image;

          if (!isValidImageFormat(data)) {
            errors[`otherImage-${index}`] = "Invalid Image Format";
          } else if (!isValidFileExtension(data)) {
            errors[`otherImage-${index}`] = "Invalid File Extension";
          } else if (!isFileSizeWithinLimit(data)) {
            errors[`otherImage-${index}`] =
              "Invalid Image Size. Image size should be less than 10mb.";
          }
        }
      });
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  return (
    <Grid container spacing={2}>
      <FullScreenLoader open={state.FullScreenLoader} />
      <Grid item xs={12} sm={12} md={6} lg={4}>
        <div style={{ marginTop: 20 }}>
          <TexBoxWithLabel
            size="small"
            placeholder="Title"
            label="Title *"
            multiline={true}
            value={eventDetail.title}
            defaultValue={eventDetail.title || ""}
            onChange={(event) => onChangeFormData("title", event)}
          />
          <ValidationError formErrors={formErrors.title} />
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={4}>
        <div style={{ marginTop: 20 }}>
          {loginInfo?.roles?.name === STRING.ROLE.HOSTS ? (
            <>
              {userData?.companyName === "" ||
              userData?.companyName === null ? (
                <>
                  <TextField
                    size="small"
                    type="text"
                    placeholder="Company / Organizer "
                    fullWidth
                    label="Company / Organizer  *"
                    name="Company / Organizer "
                    onChange={(event) =>
                      onChangeFormData("organizerName", event)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <Link
                    onClick={() => {
                      navigate("/dashboard/profile");
                    }}
                    style={{ textDecoration: "none", marginTop: 5 }}
                    component="button"
                  />
                </>
              ) : (
                <>
                  <TextField
                    size="small"
                    type="text"
                    placeholder="Company / Organizer "
                    fullWidth
                    label="Company / Organizer *"
                    name="Company / Organizer "
                    disabled
                    value={userData?.companyName}
                    onChange={(event) =>
                      onChangeFormData("organizerName", event)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <Link
                    style={{
                      fontSize: "14px",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                    href="/dashboard/profile"
                  >
                    {" "}
                    click hear to change organizer name{" "}
                  </Link>
                </>
              )}
            </>
          ) : (
            <>
              <AutoCompleteDropDown
                data={filteredOrganizers}
                onChange={(newValue) => {
                  handleOnChangeOrganizer(newValue);
                }}
                value={eventDetail.organizerId}
                label="companyName"
                dropDownDisplayLabel={"Company / Organizer *"}
                placeholder={"Select Company / Organizer"}
              />
              <ValidationError formErrors={formErrors.organizerId} />
            </>
          )}
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={4}>
        <div style={{ marginTop: 20 }}>
          <AutoCompleteDropDown
            data={eventCategories}
            onChange={(newValue) => {
              handleOnChange(newValue);
            }}
            value={eventDetail.eventCategoryId}
            label={"displayName"}
            dropDownDisplayLabel={"Event Category *"}
            placeholder={"Select Category"}
          />
          <ValidationError formErrors={formErrors.eventCategoryId} />
        </div>
      </Grid>
      <Grid item xs={12}>
        <div style={{ marginTop: 20 }}>
          <RichBoxUi
            onChangeText={(event) => {
              saveRichBox(event);
            }}
            initialData={eventDetail?.description}
          />
          <ValidationError formErrors={formErrors.description} />
        </div>
      </Grid>

      <Grid item xs={12} sm={12} md={4}>
        <div style={{ marginTop: 15 }}>
          <TextField
            size="small"
            type="file"
            label={"Choose Cover Image *"}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleChangeCoverImage}
          />
          <Typography sx={{ fontSize: "14px", color: Color.red }}>
            {isCoveredImageValidation}
          </Typography>
          <Typography
            sx={{
              width: "100%",
              fontSize: 12,
              color: "green",
            }}
          >
            Image size should be less than 10mb and in .jpg, .png formats
            <br />
            An ideal size for the images is 960 * 536 pixels
          </Typography>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <img
              src={coverImages?.data}
              style={{ width: "80%", marginTop: 2 }}
              alt=""
            />
            {coverImages?.data && (
              <Typography
                variant="caption"
                alignItems={"center"}
                sx={{ width: "20%" }}
              >
                <IconButton
                  onClick={handleDeleteClickCoverImage}
                  style={{ margin: 5 }}
                >
                  <DeleteForeverIcon color="error" />
                </IconButton>
              </Typography>
            )}
          </div>
          <ValidationError formErrors={formErrors.coveredImage} />
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <div style={{ marginTop: 15 }}>
          <ImageSelectionComponent
            onImagesSelected={setOtherImages}
            allowMultiple={true}
            label="Upload additional images"
            formErrors={formErrors}
          />
          {otherImages?.map((x: any, index: number) => {
            if (x?.id === 0 || x?.data === undefined) return null;
            return (
              <div
                key={index}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <img
                  src={x?.data}
                  style={{ width: "80%", marginTop: 2 }}
                  alt="other image"
                />
                {formErrors[`otherImage-${index}`] && (
                  <ValidationError formErrors={formErrors[`otherImage-${0}`]} />
                )}
              </div>
            );
          })}
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <div style={{ marginTop: 15 }}>
          <TexBoxWithLabel
            size="small"
            placeholder="Video Url"
            label="Video Url "
            multiline={true}
            style={Styles.labelTextBoxMg}
            value={eventDetail.VideoUrl}
            onChange={(event) => onChangeFormData("videoUrl", event)}
          />

          <ReactPlayer
            style={{ marginTop: "20px" }}
            url={eventDetail.VideoUrl}
            controls={true}
            width={"100%"}
            height={"100%"}
          />
        </div>
      </Grid>
    </Grid>
  );
};
export default EventDetails;

const Styles = {
  labelTextBoxMg: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
};
interface EventTicketConfigProps {
  wizardKey: any;
  addEventType: string;
}
